<app-language-chart *ngIf="chartType === 'AppLanguage'"></app-language-chart>
<app-version-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'AppVersion'"
></app-version-chart>
<os-type-counts-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'OsType'"
></os-type-counts-chart>
<os-version-counts-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'OsVersion'"
></os-version-counts-chart>
<app-usage-base-grid [showTitle]="false" *ngIf="chartType === 'AppUsage'">
</app-usage-base-grid>

<users-total-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'TotalUsers'"
></users-total-chart>
<users-sessions-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UserSessions'"
></users-sessions-chart>
<users-sessions-active-chart
  *ngIf="chartType === 'UsersSessionsActive'"
></users-sessions-active-chart>

<users-current-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersCurrent'"
></users-current-chart>
<users-locked-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersLocked'"
></users-locked-chart>
<users-locked-chart-total
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersLockedTotal'"
></users-locked-chart-total>
<users-removed-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersRemoved'"
></users-removed-chart>
<users-removed-chart-total
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersRemovedTotal'"
></users-removed-chart-total>
<users-created-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersCreated'"
></users-created-chart>
<users-created-chart-total
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'UsersCreatedTotal'"
></users-created-chart-total>
<annotations-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'AnnotationsSent'"
></annotations-chart>
<manuals-opened-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsOpened'"
></manuals-opened-chart>
<manuals-opened-current-chart
  *ngIf="chartType === 'ManualsOpenedCurrent'"
></manuals-opened-current-chart>
<pages-viewed-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'PagesViewed'"
></pages-viewed-chart>
<manuals-downloaded-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsDownloaded'"
></manuals-downloaded-chart>
<manuals-downloaded-least-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsDownloadedLeast'"
></manuals-downloaded-least-chart>
<manuals-downloaded-most-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsDownloadedMost'"
></manuals-downloaded-most-chart>
<manuals-downloaded-never-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsDownloadedNever'"
></manuals-downloaded-never-chart>
<manuals-language-chart
  *ngIf="chartType === 'ManualsLanguage'"
></manuals-language-chart>
<manuals-printed-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsPrinted'"
></manuals-printed-chart>
<manuals-created-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsCreated'"
></manuals-created-chart>
<manuals-updated-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === 'ManualsUpdated'"
></manuals-updated-chart>
<top-search-terms-chart
  [startDate]="startDate"
  [endDate]="endDate"
  *ngIf="chartType === ''SearchTerms"
></top-search-terms-chart>
<div *ngIf="chartType === null">Error no chart type found</div>
